export const RAGInstructionsApiTags = {
  RAGInstructions: 'RAGInstructions',
};
